//auth
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const JWT_REGISTER = "/post-jwt-register";
export const POST_FAKE_REGISTER = "/post-fake-register";

export const USER_CHANGE_PASSWORD = "/user-change-password";

// profile & settings
export const GET_PROFILE_DETAILS = "/profile-details";
export const GET_USER_SETTINGS = "/user-settings";
export const UPDATE_ETTINGS = "/update-user-settings";

// contacts
export const GET_CONTACTS = "/api/contacts";
export const INVITE_CONTACT = "/invite-contact";

// calls
export const GET_CALLS_LIST = "/calls-list";

// bookmarks
export const GET_BOOKMARKS_LIST = "/bookmarks-list";
export const DELETE_BOOKMARK = "/bookmarks-delete";
export const UPDATE_BOOKMARK = "/bookmarks-update";

// oauth connectors & connections
export const GET_OAUTH_CONNECTORS = "/api/oauth/connectors";
export const CREATE_OAUTH_CONNECTOR = "/api/oauth/connectors";
export const UPDATE_OAUTH_CONNECTOR = "/api/oauth/connectors";
export const DELETE_OAUTH_CONNECTOR = "/api/oauth/connectors";

export const GET_OAUTH_CONNECTIONS = "/api/oauth/connections";
export const INITIATE_OAUTH_FLOW = "/api/oauth/connections";
export const DELETE_OAUTH_CONNECTION = "/api/oauth/connections";
export const REFRESH_OAUTH_CONNECTION = "/api/oauth/connections";
export const TEST_OAUTH_CONNECTION = "/api/oauth/proxy";
export const OAUTH_PROXY_REQUEST = "/api/oauth/proxy";

// oauth webhooks
export const GET_WEBHOOK_EVENTS = "/api/oauth/webhooks/events";
export const WEBHOOK_SUBSCRIPTIONS = "/api/oauth/webhooks/subscriptions";

// chats
export const GET_FAVOURITES = "/get-favourites";
export const GET_DIRECT_MESSAGES = "/get-direct-messages";
export const GET_CHANNELS = "/get-channles";
export const ADD_CONTACTS = "/add-contact";
export const CREATE_CHANNEL = "/create-channel";
export const GET_CHAT_USER_DETAILS = "/get-user-details";
export const GET_CHAT_USER_CONVERSATIONS = "/get-user-conversations";
export const SEND_MESSAGE = "/send-message";
export const RECEIVE_MESSAGE = "/receive-message";
export const READ_MESSAGE = "/read-message";
export const RECEIVE_MESSAGE_FROM_USER = "/receive-message-from-user";
export const DELETE_MESSAGE = "/delete-message";
export const FORWARD_MESSAGE = "/forward-message";
export const DELETE_USER_MESSAGES = "/delete-user-messages";
export const TOGGLE_FAVOURITE_CONTACT = "/toggle-favourite-contact";
export const GET_ARCHIVE_CONTACT = "/get-archive-contacts";
export const TOGGLE_ARCHIVE_CONTACT = "/toggle-archive-contact";
export const READ_CONVERSATION = "/read-conversation";
export const DELETE_IMAGE = "/user-delete-img";

// pricing
export const GET_TACITS_BALANCE = "/api/pricing/balance";
export const GET_TACITS_DAILY = "/api/pricing/tacits-daily";
export const GET_CREDIT_PACKAGES = "/api/pricing/credit-packages";
export const POST_PURCHASE_TACITS = "/api/pricing/credits/purchase";
export const GET_CREDIT_HISTORY = "/api/pricing/credits/history";

// feature flags
export const GET_FEATURE_FLAGS = "/api/feature-flags";

// kpi
export const GET_AGENT_KPI_DASHBOARD = "/api/agent/kpi/dashboard";

// groups
export const GET_CHANNEL_DETAILS = "/get-channel-details";
